import { Form, InputNumber } from 'antd';

function QueryRateLimitFields() {
  return (
    <section className="capacity-drawer__section">
      <h3 className="capacity-drawer__heading">Query rate limit</h3>
      <div className="capacity-drawer__grid capacity-drawer__grid--2">
        <Form.Item
          name="queryRequestsPerMinute"
          label="Requests per minute per session and per IP, per analytics pod"
          extra="For /incorta/bff/v1/query. Copied into clusters created on this size while the query rate limit mode is observe or enforce: each session (signed-in user or API token) and each public IP may then send this × the cluster's analytics pods per minute. Existing clusters keep their own number. Empty: new clusters of this size are not limited."
        >
          <InputNumber
            min={1}
            max={1000000}
            precision={0}
            placeholder="Not limited"
            addonAfter="/ min"
          />
        </Form.Item>
        <Form.Item
          name="queryMaxConcurrentRequests"
          label="Concurrent requests per pod"
          extra="For POST /incorta/bff/v1/query. How many one pod of this size runs at once; any more get a 429 straight away, so a burst cannot pile up on the pod. Copied into clusters created on this size while the mode is observe or enforce, and rejects in both. Existing clusters keep their own number. Empty: new clusters of this size are not capped."
        >
          <InputNumber
            min={1}
            max={100000}
            precision={0}
            placeholder="Not capped"
            addonAfter="at once"
          />
        </Form.Item>
      </div>
    </section>
  );
}

export default QueryRateLimitFields;
